import { emptyApi } from './emptyApi'
import {
  camelCaseResponse,
  providesList,
  toTitleCase
} from '../../shared/Functions'
import {
  ApiResetPasswordData,
  ApiResetTokenData,
  GeneralApiResponse,
  User,
  UserLoginData
} from '../../types'

// API Response Types
interface UserRole {
  name: string
}

interface UserDetails {
  firstName: string
  lastName: string
  bio: string
}

interface UserFromApi {
  id: number
  email: string
  details: UserDetails
  roles: UserRole[]
}

export const userService = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getOfficers: builder.query<User[], void>({
      query: () => '/users?officers=true',
      transformResponse: (response: unknown) => {
        return processUsers(
          camelCaseResponse(
            response as Record<string, unknown>
          ) as UserFromApi[]
        )
      },
      providesTags: (results) => providesList(results, 'User')
    }),
    loginUser: builder.mutation<User, UserLoginData>({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: processCredentials(credentials)
      }),
      transformResponse: (response: unknown) =>
        camelCaseResponse(response as Record<string, unknown>) as User
    }),
    requestPasswordReset: builder.mutation<
      ApiResetPasswordData,
      ApiResetPasswordData
    >({
      query: (data: ApiResetPasswordData) => ({
        url: '/user/reset_password',
        method: 'PATCH',
        body: data
      }),
      transformResponse: (response: unknown) =>
        camelCaseResponse(
          response as Record<string, unknown>
        ) as ApiResetPasswordData
    }),
    checkResetToken: builder.query<ApiResetTokenData, string>({
      query: (token: string) => `/user/reset_token/${token}`,
      transformResponse: (response: unknown) =>
        camelCaseResponse(
          response as Record<string, unknown>
        ) as ApiResetTokenData
    }),
    setNewPassword: builder.mutation<GeneralApiResponse, ApiResetPasswordData>({
      query: (data: ApiResetPasswordData) => ({
        url: `/user/set_new_password?reset_password_token=${data.token}`,
        method: 'PATCH',
        body: data
      }),
      transformResponse: (response: unknown) =>
        camelCaseResponse(
          response as Record<string, unknown>
        ) as GeneralApiResponse
    })
  })
})

export const {
  useGetOfficersQuery,
  useLoginUserMutation,
  useRequestPasswordResetMutation,
  useCheckResetTokenQuery,
  useSetNewPasswordMutation
} = userService

function processUsers(apiUsers: UserFromApi[]): User[] {
  return apiUsers.map((user) => {
    const position = user.roles.filter((role) => {
      return (
        role.name === 'president' ||
        role.name === 'vice_president' ||
        role.name === 'secretary' ||
        role.name === 'treasurer'
      )
    })
    return {
      id: user.id,
      firstName: user.details.firstName,
      lastName: user.details.lastName,
      email: user.email,
      roles: user.roles.map((role) => role.name),
      bio: user.details.bio,
      position:
        position && position.length !== 0 ? toTitleCase(position[0].name) : '',
      token: '',
      refreshToken: '',
      tokenExpiry: null
    }
  })
}

function processCredentials(credentials: UserLoginData): UserLoginData {
  return credentials
}
